import React from 'react';

import { Title } from '@unimed-fesp/components';

import { Container } from './styles';
import theme from '../../../styles/theme';

export default function SectionHeader({
  sectionName,
  subtextSectionName,
  marginBottom,
  padding,
}) {
  return (
    <Container padding={padding} marginBottom={marginBottom}>
      <Title
        fontSize={54}
        color={theme.titleGray}
        text={sectionName}
        marginBottom={-5}
      />
      <Title
        text={subtextSectionName}
        font="16px unimed_slabregular"
        color={theme.grey}
      />
    </Container>
  );
}
